import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import router from 'src/router';
import { minLength } from 'vuelidate/lib/validators';
import * as auth from 'core/auth';
import * as api from 'core/api';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component({
    validations: {
        model: {
            firstName: { minLength: minLength(1) },
            lastName: { minLength: minLength(1) },
            birthday: {},
            gender: {},
            country: {},
            city: {}
        }
    }
})
export default class AccountProfileComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Watch('user.gender')
    onUserGenderChanged(val: string) {
        if (val) {
            if (val.toLowerCase() === 'male') {
                this.gender = flights.Gender.Male;
            }
            else if (val.toLowerCase() === 'female') {
                this.gender = flights.Gender.Female;
            }
        }
    }

    user: api.UserWithProfile | null = null;

    gender: flights.Gender | null = null;

    country: string | null = null;

    city: string | null = null;

    submitted: boolean = false;

    mounted() {
        window.document.title = i18next.t('title_profile');

        this.loadModel();
    }

    loadModel() {
        this.$auth.getCurrentUserWithProfile().then(
            (result: api.UserWithProfile) => {
                this.user = result;

                this.gender = flights.Gender[this.user.gender];

                if (this.user.country) {
                    this.country = this.user.country.uniqueId.toString();
                }
                if (this.user.city) {
                    this.city = this.user.city.uniqueId.toString();
                }
            },
            () => {
                router.push('/signin');
            }
        );
    }

    get genderOptions() {
        return [
            {
                label: i18next.t('label_gender_' + flights.Gender[flights.Gender.Male].toLowerCase()),
                value: flights.Gender.Male
            },
            {
                label: i18next.t('label_gender_' + flights.Gender[flights.Gender.Female].toLowerCase()),
                value: flights.Gender.Female
            }
        ];
    }

    get selectCountries() {
        const result: any = this.user!.countries.map((country) => {
            return {
                label: country.localizedName,
                value: country.uniqueId
            };
        });

        if (result.length > 0) {
            result.unshift({label: '', value: null});
        }

        return result;
    }

    get selectCities() {
        const result = this.user!.cities.map((city) => {
            return {
                label: city.localizedName,
                value: city.uniqueId
            };
        });

        result.unshift({ label: '', value: 0 });

        return result;
    }

    get selectNextTripPurposes() {
        return this.user!.allNextTripPurposes.map((item) => {
            return {
                label: item.name,
                value: item.id
            };
        });
    }

    onCountryChange() {
        this.city = null;
        this.user!.city = null;

        if (this.country) {
            this.user!.country = this.user!.countries.find(c => c.uniqueId == parseInt(this.country!)) || null;

            new api.DestinationService().listCities(this.country).then(
                (result: api.Destination[]) => {
                    this.user!.cities = result;
                },
                () => {}
            );
        } else {
            this.user!.country = null;
            this.user!.cities = [];
        }
    }

    onCityChange() {
        if (this.city) {
            this.user!.city = this.user!.cities.find(c => c.uniqueId == parseInt(this.city!)) || null;
        } else {
            this.user!.city = null;
        }
    }

    onGenderChange() {
        this.user!.gender = flights.Gender[this.gender!];

        if (!this.user!.birthday) {
            document.getElementById('birthday')!.focus();
        }
    }

    onSubmit() {
        this.$v.model!.$touch();

        if (this.$v.model!.$error) {
            (<any>this.$root.$refs).messageDialog.show({
                message: i18next.t('error_fields')
            });
        } else {
            this.submitted = true;

            this.$auth.updateProfile(this.user!).then(
                () => {
                    this.submitted = false;

                    (<any>this.$root.$refs).messageDialog.show({
                        message: i18next.t('label_profile_updated')
                    });
                },
                (error) => {
                    this.submitted = false;

                    (<any>this.$root.$refs).messageDialog.show({
                        message: error?.response?.data?.message ? error.response.data.message : i18next.t('error_server_tryagain')
                    });

                    if (error.response) {
                        console.log('XHR failed', error.response.status, error.response.data);
                    } else {
                        console.log('XHR error', error.message);
                    }
                }
            );
        }
    }
}
